export enum BoardPermissionAction {
  VIEW_IDEAS = 'view_ideas',
  CREATE_IDEA = 'create_idea',
  UPDATE_METADATA = 'update_metadata',
  DELETE = 'delete',
  DISCOVER = 'discover'
}